import { Selector } from '@ngxs/store';

import { CourtEventModalsStateModel } from './court-event-modals.state.model';
import { CourtEventModalsState } from './court-event-modals.state';

export class CourtEventModalsSelectors {
    @Selector([CourtEventModalsState])
    static isCancelReasonFormLoading(state: CourtEventModalsStateModel): boolean {
        return state.cancelReasonForm.isLoading;
    }

    @Selector([CourtEventModalsState])
    static isCancelReasonFormValid(state: CourtEventModalsStateModel): boolean {
        return state.cancelReasonForm.status === 'VALID';
    }

    @Selector([CourtEventModalsState])
    static isCancelBlockedSlotFormLoading(state: CourtEventModalsStateModel): boolean {
        return state.cancelBlockedSlotForm.isLoading;
    }

    @Selector([CourtEventModalsState])
    static isCancelBlockedSlotFormValid(state: CourtEventModalsStateModel): boolean {
        return state.cancelBlockedSlotForm.status === 'VALID';
    }
}
